// Version stamp for the consent copy shown on the safety screen. Bump this
// whenever the consent/privacy wording changes materially — it is stored on
// each session (sessions.consent_version) so we know which wording a user
// agreed to.
export const CONSENT_VERSION = "2026-07-19";
